<div class="container main-font" *ngIf="notification">
  <div class="mx-4 mt-3 row">
    <div class="d-flex">
      <mat-form-field appearance="fill" color="accent" class="col-3">
        <mat-label>Categoria</mat-label>
        <mat-select
          name="categorySelect"
          id="categorySelect"
          [formControl]="categoryControl"
          class="col-12">
          <mat-option
            *ngFor="let category of categories"
            class="main-font"
            [ngClass]="
              category.alias == 'Feedback 360' ||
              category.alias == 'Sondaggi' ||
              category.alias == 'Autovalutazione' ||
              category.alias == 'Timesheet'
                ? 'chagne-option'
                : ''
            "
            [value]="category.alias"
            (click)="chooseCategory(categoryControl.value)"
            (keydown)="chooseCategory(categoryControl.value)"
            >{{ category.alias }}
            <mat-icon
              *ngIf="
                category.alias != 'Feedback 360' &&
                category.alias != 'Sondaggi' &&
                category.alias != 'Autovalutazione' &&
                category.alias != 'Timesheet'
              "
              class="icon-color"
              [innerHtml]="getNotiCategory(category.alias)"></mat-icon>

            <div
              *ngIf="
                category.alias == 'Feedback 360' ||
                category.alias == 'Sondaggi' ||
                category.alias == 'Autovalutazione' ||
                category.alias == 'Timesheet'
              "
              class="me-3"
              [innerHTML]="getNotiCategory(category.alias)"></div>
          </mat-option>
        </mat-select>
        <button
          *ngIf="categoryControl.value != ''"
          matTooltip="Deseleziona categoria"
          matSuffix
          mat-icon-button
          (click)="stopEventPropagation($event); clearSelect()">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-form-field>

      <div
        class="main-font ms-auto justify-content-center align-items-center d-flex me-3"
        *ngIf="notification[0]">
        <mat-icon
          class="my-mt-email"
          type="submit"
          color="accent"
          *ngIf="onlyCheck && !CountUnRead"
          (click)="markAsUnreadAllSelected()"
          (keydown)="markAsUnreadAllSelected()"
          matTooltip="Segna come non letto"
          >mark_email_unread</mat-icon
        >
        <mat-icon
          type="submit"
          color="accent"
          *ngIf="onlyCheck && CountUnRead"
          (click)="markAsReadAllSelected()"
          (keydown)="markAsReadAllSelected()"
          matTooltip="Segna come letto"
          >drafts</mat-icon
        >
        <mat-icon
          type="submit"
          (click)="deleteNotificationModal()"
          color="accent"
          *ngIf="onlyCheck"
          matTooltip="Elimina"
          class="ms-1"
          >delete</mat-icon
        >

        <mat-checkbox
          value=""
          color="accent"
          class="ms-2"
          [checked]="onlyCheck"
          (change)="changeCheckBox(null, $event.checked)"></mat-checkbox>

        <mat-icon [matMenuTriggerFor]="menu" class="cursor-pointer"
          >expand_more</mat-icon
        >
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            *ngFor="let type of types"
            [value]="type"
            (click)="onSelectClick(type)">
            {{ type }}
            <span
              *ngIf="currentType == type"
              class="material-symbols-outlined small-check">
              check
            </span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="notification">
      <mat-accordion hideToggle>
        <div
          *ngFor="let item of obs | async; trackBy: notificationTrackBy"
          [ngSwitch]="item?.data.category">
          <div
            class="my-3 mx-2"
            *ngSwitchCase="'Condivisione'"
            [ngClass]="{
              'noti-border-new': item.read_at == null,
              'noti-border-declined':
                item.read_at != null &&
                (item.data.share.status == 'declined' ||
                  item.data.status == 'declined'),
              'noti-border-approved':
                item.read_at != null && item.data.status == 'approved',
              'noti-border-pending':
                item.read_at != null && item.data.share.status == 'pending'
            }">
            <mat-expansion-panel
              (closed)="
                item.read_at == null ? set_Read(item.id, item.read_at) : ''
              ">
              <!-- al closed del dialog togliere chiamata a index, provare a settare invece variabile booleana -->
              <mat-expansion-panel-header>
                <mat-panel-title class="noti-description">
                  <div class="me-2 my-auto">
                    <button class="btn">
                      <img
                        [src]="
                          item.data.sender
                            ? item.data.sender.filestorage?.path
                            : defaultSystemImg
                        "
                        matTooltipPosition="below"
                        class="avatar rounded-circle"
                        (click)="
                          stopEventPropagation($event);
                          getElement(item.data.sender.id)
                        " />
                    </button>
                  </div>
                  <span class="name_padding align-middle">
                    {{ item.data.sender.first_name }}
                    {{ item.data.sender.last_name }}
                  </span>
                </mat-panel-title>
                <mat-panel-description
                  class="d-flex fs-6 justify-content-end mx-auto my-auto text-end">
                  <p
                    [ngClass]="{
                      give: item.data.share?.share_user[0]?.is_creator == 0,
                      receive: item.data.share?.share_user[0]?.is_creator == 1
                    }"
                    *ngIf="item.data.share.share_user"
                    class="text-center my-auto d-flex align-items-center justify-content-center typology">
                    {{
                      item.data.share?.share_user[0]?.is_creator == 1
                        ? 'Ricevere'
                        : 'Dare'
                    }}
                  </p>

                  <!-- Status notifica -->
                  <div [ngSwitch]="item.data.share.status" class="col-1">
                    <mat-icon
                      *ngSwitchCase="'declined'"
                      class="noti-icon"
                      matTooltip="Declinata">
                      clear
                    </mat-icon>
                    <span
                      *ngSwitchCase="'pending'"
                      class="material-symbols-outlined align-middle"
                      matTooltip="Pending">
                      hourglass_empty
                    </span>
                    <mat-icon
                      *ngSwitchCase="'approved'"
                      class="noti-icon align-middle"
                      matTooltip="Approvata">
                      done
                    </mat-icon>

                    <mat-icon
                      *ngSwitchCase="'deleted'"
                      class="noti-icon align-middle"
                      matTooltip="Eliminata">
                      delete
                    </mat-icon>
                  </div>

                  <p class="my-auto col-3">
                    {{ item.created_at | date: 'd/MM/yyyy, HH:mm' }}
                  </p>

                  <!-- Categoria notifica -->
                  <div [ngSwitch]="item.data.category" class="col-1">
                    <mat-icon
                      *ngSwitchCase="'Condivisione'"
                      class="noti-icon align-middle"
                      matTooltip="Condivisione">
                      share
                    </mat-icon>
                    <mat-icon
                      *ngSwitchCase="'Consapevolezza'"
                      class="noti-icon align-middle"
                      matTooltip="Consapevolezza">
                      receipt
                    </mat-icon>
                    <mat-icon
                      *ngSwitchCase="'Competenze'"
                      class="noti-icon align-middle"
                      matTooltip="Competenze">
                      settings
                    </mat-icon>
                    <mat-icon
                      *ngSwitchCase="'Feedback'"
                      class="noti-icon align-middle"
                      matTooltip="Feedback">
                      feedback
                    </mat-icon>
                  </div>

                  <mat-checkbox
                    color="accent"
                    class=""
                    [style.visibility]="
                      item.data.category == 'Condivisione'
                        ? item.data.share.status == 'pending'
                          ? 'hidden'
                          : 'visible'
                        : 'visible'
                    "
                    [checked]="item.check"
                    (click)="stopEventPropagation($event)"
                    (change)="
                      changeCheckBox(item.id, item.check)
                    "></mat-checkbox>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <!-- Descrizione notifica condivisione -->
              <div class="row noti-description mt-3">
                <div class="col-1 arg_padding text-center">
                  <img
                    [src]="
                      utilityService.getSanitizeUrl(
                        item.data.share.arguments.filestorage?.path ?? ''
                      )
                    "
                    width="50"
                    height="50"
                    [matTooltip]="item.data.share.arguments.alias"
                    class="arg_img" />
                </div>
                <div class="pt-3 ps-0 main-font col-10">
                  <p>
                    Descrizione condivisione: {{ item.data.share.description }}
                  </p>
                  <p *ngIf="item.data.share.status == 'declined'">
                    Condivisione declinata
                  </p>
                  <p *ngIf="item.data.share.status == 'approved'">
                    Condivisione approvata
                  </p>
                  <p *ngIf="item.data.share.status == 'deleted'">
                    {{ item.data.message }}
                  </p>
                </div>
              </div>
              <div class="d-flex">
                <p
                  class="col-3 d-flex align-items-center justify-content-start m-0 mt-2 ms-2 col-3">
                  {{ item.data.share.duration }} min
                  <mat-icon class="noti-icon ms-2">access_time</mat-icon>
                </p>
              </div>
            </mat-expansion-panel>
          </div>

          <!-- box notifiche feedback360 -->
          <div
            class="my-3 mx-2"
            *ngSwitchCase="'Feedback 360'"
            [ngClass]="{ 'noti-border-new': item.read_at == null }">
            <mat-expansion-panel
              (closed)="
                item.read_at == null ? set_Read(item.id, item.read_at) : ''
              ">
              <mat-expansion-panel-header class="panel-header-feedback">
                <mat-panel-title class="noti-description">
                  <div class="me-2 my-auto container-img-feedback">
                    <img
                      src="assets/images/Shared/sondaggi.svg"
                      alt="sondaggi"
                      class="rounded-circle img-feedback"
                      matTooltip="Sondaggi" />
                  </div>
                  <span class="name_padding align-middle text-content">
                    {{ this.truncateText(item.data.alias) }}
                  </span>
                </mat-panel-title>
                <mat-panel-description
                  class="d-flex fs-6 justify-content-end mx-auto my-auto text-end align-items-center">
                  <p class="my-auto col-3">
                    {{ item.data.date | date: 'dd/MM/yyyy, HH:mm' }}
                  </p>

                  <div class="col-1">
                    <img
                      src="assets/images/Shared/sondaggi360.svg"
                      height="30px"
                      width="30px"
                      alt="feedback360"
                      matTooltip="Feedback 360" />
                  </div>
                  <mat-checkbox
                    color="accent"
                    [checked]="item.check"
                    (click)="stopEventPropagation($event)"
                    (change)="
                      changeCheckBox(item.id, item.check)
                    "></mat-checkbox>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <!-- Descrizione notifica feedback360 -->
              <div class="row noti-description mt-3">
                <div class="col-1 arg_padding text-center">
                  <button type="button" class="btn">
                    <div class="position-relative">
                      <img
                        [src]="item.data?.image"
                        [alt]="item.data.name"
                        [matTooltip]="item.data?.name"
                        (click)="
                          stopEventPropagation($event);
                          getElement(item.data.target_id)
                        "
                        class="user-image" />
                      <img
                        class="position-absolute top-5 start-88 translate-middle"
                        src="assets/images/Shared/target.svg"
                        alt=""
                        width="17px"
                        height="17px"
                        matTooltip="Target" />
                    </div>
                  </button>
                </div>
                <div class="pt3 ps-0 main-font col-10">
                  <p class="mb-0">Descrizione:</p>
                  <div [innerHTML]="formatDescription(item.data.message)"></div>
                  <div *ngIf="item.data.note">
                    <p class="mb-0">Note:</p>
                    <p>{{ item.data.note }}</p>
                  </div>
                </div>
              </div>

              <div class="row mt-3 arg_padding">
                <div
                  class="col-5 d-flex justify-content-between align-items-center">
                  <p *ngIf="item.data.start_date" class="mb-0">
                    Data inizio:
                    {{ item.data.start_date | date: 'dd-MM-yyyy' }}
                  </p>
                  <p *ngIf="item.data.end_date" class="mb-0">
                    Data fine: {{ item.data.end_date | date: 'dd-MM-yyyy' }}
                  </p>
                </div>
                <div class="col-7 d-flex justify-content-end">
                  <button
                    *ngIf="item.data.reference_id"
                    mat-raised-button
                    type="button"
                    color="accent"
                    class="text-white"
                    (click)="
                      redirectToSurvey(
                        item.data.reference_id,
                        item.data.receiving_role,
                        $event
                      );
                      set_Read(item.id, item.read_at)
                    ">
                    {{
                      item.data.receiving_role == 1
                        ? 'Vai al dettaglio'
                        : item.data.receiving_role == 2
                          ? 'Rispondi al sondaggio'
                          : ''
                    }}
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          </div>

          <!-- Autovalutazione -->
          <div
            class="my-3 mx-2"
            *ngSwitchCase="'Autovalutazione'"
            [ngClass]="{ 'noti-border-new': item.read_at == null }">
            <mat-expansion-panel
              (closed)="
                item.read_at == null ? set_Read(item.id, item.read_at) : ''
              ">
              <mat-expansion-panel-header class="panel-header-feedback">
                <mat-panel-title class="noti-description">
                  <div class="me-2 my-auto container-img-feedback">
                    <img
                      src="assets/images/Shared/sondaggi.svg"
                      alt="sondaggi"
                      class="rounded-circle img-feedback"
                      matTooltip="Sondaggi" />
                  </div>
                  <span class="name_padding align-middle text-content">
                    {{ this.truncateText(item.data.alias) }}
                  </span>
                </mat-panel-title>

                <mat-panel-description
                  class="d-flex fs-6 justify-content-end mx-auto my-auto text-end align-items-center">
                  <p class="my-auto col-3">
                    {{ item.data.date | date: 'dd/MM/yyyy, HH:mm' }}
                  </p>

                  <div class="col-1">
                    <img
                      src="assets/images/Shared/self-evaluation.svg"
                      alt="Autovalutazione"
                      height="30px"
                      width="30px"
                      matTooltip="Autovalutazione" />
                  </div>

                  <mat-checkbox
                    color="accent"
                    [checked]="item.check"
                    (click)="stopEventPropagation($event)"
                    (keydown)="stopEventPropagation($event)"
                    (change)="
                      changeCheckBox(item.id, item.check)
                    "></mat-checkbox>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <!-- Descrizione autovalutazione -->
              <div class="row noti-description mt-3">
                <div class="col-1 arg-padding text-center"></div>
                <div class="pt-3 ps-0 main-font col-10">
                  <p class="mb-0">Descrizione:</p>
                  <div [innerHTML]="formatDescription(item.data.message)"></div>
                  <p>
                    {{ item.data.users ? item.data.users.join(', ') : '' }}
                  </p>
                  <div *ngIf="item.data.note">
                    <p class="mb-0">Note:</p>
                    <p>{{ item.data.note }}</p>
                  </div>
                </div>
              </div>

              <div class="row mt-3 arg_padding">
                <div
                  class="col-5 d-flex justify-content-between align-items-center">
                  <p *ngIf="item.data.start_date" class="mb-0">
                    Data inizio:
                    {{ item.data.start_date | date: 'dd-MM-yyyy' }}
                  </p>
                  <p *ngIf="item.data.end_date" class="mb-0">
                    Data fine: {{ item.data.end_date | date: 'dd-MM-yyyy' }}
                  </p>
                </div>
                <div class="col-7 d-flex justify-content-end">
                  <button
                    *ngIf="item.data.reference_id"
                    mat-raised-button
                    type="button"
                    color="accent"
                    class="text-white"
                    (click)="
                      redirectToSurvey(
                        item.data.reference_id,
                        item.data.receiving_role,
                        $event
                      );
                      set_Read(item.id, item.read_at)
                    ">
                    {{
                      item.data.receiving_role == 1
                        ? 'Vai al dettaglio'
                        : item.data.receiving_role == 2
                          ? 'Rispondi al sondaggio'
                          : ''
                    }}
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          </div>

          <!-- box notifice Timesheet -->
          <div
            class="my-3 mx-2"
            *ngSwitchCase="'Timesheet'"
            [ngClass]="{ 'noti-border-new': item.read_at == null }">
            <mat-expansion-panel
              (closed)="
                item.read_at == null ? set_Read(item.id, item.read_at) : ''
              ">
              <mat-expansion-panel-header class="panel-header-feedback">
                <mat-panel-title class="noti-description">
                  <div class="me-2 my-auto container-img-feedback">
                    <img
                      [src]="
                        utilityService.getSanitizeUrl(
                          item.data.sender.filestorage?.path ?? ''
                        )
                      "
                      alt="utente"
                      matTooltipPosition="below"
                      class="avatar rounded-circle"
                      (click)="
                        stopEventPropagation($event);
                        getElement(item.data.sender.id)
                      "
                      (keydown)="
                        stopEventPropagation($event);
                        getElement(item.data.sender.id)
                      " />
                  </div>
                  <span class="name_padding align-middle text-content">
                    {{
                      item.data.sender.first_name +
                        ' ' +
                        item.data.sender.last_name
                    }}
                  </span>
                </mat-panel-title>

                <mat-panel-description
                  class="d-flex fs-6 justify-content-end mx-auto my-auto text-center">
                  <p class="my-auto col-3">
                    {{ item.created_at | date: 'dd/MM/yyyy, HH:mm' }}
                  </p>

                  <div class="col-1">
                    <img
                      src="assets/images/Shared/overview.svg"
                      alt="timesheet"
                      height="30px"
                      width="30px"
                      matTooltip="Timesheet" />
                  </div>

                  <mat-checkbox
                    color="accent"
                    [checked]="item.check"
                    (click)="stopEventPropagation($event)"
                    (keydown)="stopEventPropagation($event)"
                    (change)="
                      changeCheckBox(item.id, item.check)
                    "></mat-checkbox>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <!-- Descrizione timesheet -->
              <div class="row noty-description mt-3">
                <div class="col-1 arg-padding text-center"></div>
                <div class="pt-3 ps-0 main-font col-10">
                  <p class="mb-0">Descrizione:</p>
                  <p>
                    {{ item.data.message }}
                  </p>
                  <p class="mb-0">Nota:</p>
                  <p>{{ item.data.note }}</p>
                </div>
              </div>
              <div class="row mt-3 arg_padding">
                <div class="d-flex justify-content-end">
                  <button
                    mat-raised-button
                    type="button"
                    color="accent"
                    class="text-white"
                    (click)="
                      redirectToTimesheet(
                        item.data?.date,
                        item.data.message.includes('ACCETTATA')
                          ? item.notifiable_id
                          : item.data.sender,
                        $event
                      );
                      set_Read(item.id, item.read_at)
                    ">
                    Vai a timesheet
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          </div>

          <!-- box notifiche generali -->
          <div
            class="my-4 mx-2"
            *ngSwitchDefault=""
            [ngClass]="{ 'noti-border-new': item.read_at == null }">
            <mat-expansion-panel
              (closed)="
                item.read_at == null ? set_Read(item.id, item.read_at) : ''
              ">
              <mat-expansion-panel-header>
                <mat-panel-title class="noti-description">
                  <div class="me-2 my-auto">
                    <!-- notifica da un admin -->
                    <button
                      *ngIf="
                        item.data.category == 'Sistema' ||
                          item.data.category == 'Sistema prof' ||
                          item.data.category == 'Hobby';
                        else othersBlock
                      "
                      type="button"
                      class="btn">
                      <img
                        [src]="
                          item.data.category == 'Hobby'
                            ? defaultHobbyImg
                            : defaultSystemImg
                        "
                        [matTooltip]="item.data.category"
                        matTooltipPosition="below"
                        class="avatar rounded-circle" />
                    </button>

                    <!-- notifica da qualunque utente -->
                    <ng-template #othersBlock>
                      <button type="button" class="btn">
                        <img
                          [src]="
                            utilityService.getSanitizeUrl(
                              item.data.sender.filestorage?.path ?? ''
                            )
                          "
                          matTooltipPosition="below"
                          class="avatar rounded-circle"
                          (click)="
                            stopEventPropagation($event);
                            getElement(item.data.sender.id)
                          " />
                      </button>
                    </ng-template>
                  </div>
                  <span class="name_padding">{{
                    item.data.category == 'Sistema' ||
                    item.data.category == 'Sistema prof' ||
                    item.data.category == 'Hobby'
                      ? item.data.category
                      : item.data.sender.first_name +
                        ' ' +
                        item.data.sender.last_name
                  }}</span>
                </mat-panel-title>
                <mat-panel-description
                  class="d-flex fs-6 justify-content-end mx-auto my-auto text-end">
                  <p
                    [ngClass]="{ give: item.data.category == 'Hobby' }"
                    *ngIf="item.data.category == 'Hobby'"
                    class="text-center my-auto d-flex align-items-center justify-content-center typology">
                    Richiesta
                  </p>
                  <p class="my-auto col-3">
                    {{ item.created_at | date: 'd/MM/yyyy, HH:mm' }}
                  </p>
                  <!-- icona categoria notifica -->
                  <!-- commento -->
                  <div
                    class="col-1 icon-color"
                    [matTooltip]="item.data.category"
                    matTooltipPosition="below"
                    [innerHtml]="getNotiCategory(item.data.category)"></div>
                  <mat-checkbox
                    color="accent"
                    class=""
                    [checked]="item.check"
                    (click)="stopEventPropagation($event)"
                    (change)="
                      changeCheckBox(item.id, item.check)
                    "></mat-checkbox>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <!-- Descrizione notifica generale -->
              <div class="row noti-description mt-3">
                <div
                  class="col-1 arg_padding text-center"
                  [matTooltip]="item.data.name"
                  matTooltipPosition="above">
                  <img
                    *ngIf="item.data.image"
                    [src]="item.data.image"
                    width="50"
                    height="50" />
                </div>
                <div class="pt-3 ps-0 main-font col-10">
                  <p>Descrizione: {{ item.data.message }}</p>
                </div>
              </div>

              <!-- Azioni notifica SBI -->
              <mat-action-row
                *ngIf="item.data.category === 'Sbi'"
                class="border-top-0">
                <button
                  type="button"
                  mat-raised-button
                  color="accent"
                  (click)="set_Read(item.id, item.read_at); goToSbi(item.data)">
                  Vai all'SBI
                </button>
              </mat-action-row>

              <!-- Azioni notifica Calendario -->
              <mat-action-row
                *ngIf="item.data.category === 'Calendario'"
                class="border-top-0">
                <button
                  *ngIf="item.data.reference_id"
                  type="button"
                  mat-raised-button
                  color="accent"
                  (click)="
                    set_Read(item.id, item.read_at); goToCalendar(item.data)
                  ">
                  Vai alla richiesta
                </button>
              </mat-action-row>

              <!-- Azioni notifica wiki -->
              <mat-action-row
                *ngIf="
                  item.data.category == 'Richiesta supporto' ||
                  item.data.category == 'Commento' ||
                  item.data.category == 'Consiglio utile' ||
                  item.data.category == 'Documentazione' ||
                  item.data.category == 'Hobby' ||
                  item.data.category == 'Feedback'
                "
                class="border-top-0">
                <button
                  type="button"
                  mat-raised-button
                  color="accent"
                  (click)="set_Read(item.id, item.read_at); goToNew(item.data)">
                  Vai alla pagina
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </div>
          <!-- fine notifica Sistema -->
        </div>
      </mat-accordion>
      <div class="text-center m-4" *ngIf="!notification.length">
        <p>Nessuna notifica</p>
      </div>
    </div>
    <mat-paginator
      *ngIf="totalItems > 4"
      [pageSizeOptions]="[5, 10, 25, 100]"
      [length]="totalItems"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
    <div></div>
  </div>
</div>
